
import "@/sass/globals.scss";

import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { configStore, uiStore } from "@/store/store";
import Notifications from "@/components/Notifications/Notifications.vue";
import Builder from "@/Builder.vue";
import BrowseMode from "@/BrowseMode.vue";
import { logEvent } from "@/util/tracking";
import { getPlatform } from "@/util/get-platform";
import { handleIframeMessageFromOnboardingApp } from "./lib/onboarding";
import { setUi } from "./lib/singularity/ui";
import { setUiStoreToSingularityMode, isFutureLayerMode } from "./futurelayer/ui/ui";

@Component({
  components: {
    BrowseMode,
    Builder,
    Notifications
  }
})
export default class App extends Vue {
  beforeMount() {
    if (window.Breakdance.singularity) {

      setUiStoreToSingularityMode();

      if (window.Breakdance.singularity === "step1") {
        setUi("step1");
      } else if (window.Breakdance.singularity === "step2") {
        setUi("step2");
      }

    } else {
      uiStore.setMode({ mode: window.Breakdance.initialMode });
    }
  }

  mounted() {
    logEvent("Builder Loaded", {
      subscriptionMode: window.Breakdance.subscriptionMode,
      builderMode: window.Breakdance.initialMode,
      theme: uiStore.settings.theme,
      url: location.href,
      title: document.title,
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    });

    if (window.Breakdance.isOnboarding)
      window.addEventListener("message", handleIframeMessageFromOnboardingApp);
  }

  get isBrowseModeEnabled() {
    return uiStore.mode?.mode === "browse";
  }

  get useCustomScrollbar() {
    if (configStore.builderMode === "breakdance") return false;

    const platform = getPlatform().toLowerCase();
    return /windows/.test(platform);
  }

  get useThinScrollbar() {
    if (configStore.builderMode === "breakdance") return false;

    return !this.useCustomScrollbar;
  }

  get useDarkMode() {
    if (configStore.builderMode === "oxygen") {
      return true;
    }

    return (
      // uiStore reference is probably necessary to make Vue re-run the watcher
      uiStore.settings.theme === "dark"
    );
  }

  get isOnboardingMode() {
    return window.Breakdance.isOnboarding;
  }

  get isFutureLayerMode() {
    return isFutureLayerMode();
  }

  get classList() {
    return {
      "breakdance-dark-mode": this.useDarkMode,
      "futurelayer-dark-mode": this.isFutureLayerMode && this.useDarkMode,
      "breakdance-preview-mode": this.isPreviewMode,
      "oxygen-custom-scrollbar": this.useCustomScrollbar,
      "oxygen-thin-scrollbar": this.useThinScrollbar,
      "breakdance-onboarding": this.isOnboardingMode
    };
  }

  get isPreviewMode() {
    return uiStore.isPreviewMode;
  }

  @Watch("useDarkMode", {
    immediate: true
  })
  darkModeWatcher(useDarkMode: boolean) {
    // @ts-ignore
    this.$vuetify.theme.dark = useDarkMode;
  }
}
